import React, { useEffect, useState } from 'react';
import { XIcon, PlusIcon, SaveIcon } from 'lucide-react';
const AdminPropertyForm = ({
  property,
  onSaved
}) => {
  const [formData, setFormData] = useState({
    id: null,
    title: '',
    description: '',
    location: '',
    pricePerNight: 0,
    propertyType: 'bnb',
    bedrooms: 1,
    beds: 1,
    bathrooms: 1,
    maxGuests: 1,
    amenities: [],
    images: [''],
    host: {
      id: 1,
      name: '',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
    }
  });
  const [newAmenity, setNewAmenity] = useState('');
  const [newImage, setNewImage] = useState('');
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (property) {
      setFormData({
        ...property
      });
    }
  }, [property]);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    if (['bedrooms', 'beds', 'bathrooms', 'maxGuests', 'pricePerNight'].includes(name)) {
      setFormData({
        ...formData,
        [name]: parseInt(value) || 0
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleHostChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      host: {
        ...formData.host,
        [name]: value
      }
    });
  };
  const addAmenity = () => {
    if (newAmenity.trim() && !formData.amenities.includes(newAmenity.trim())) {
      setFormData({
        ...formData,
        amenities: [...formData.amenities, newAmenity.trim()]
      });
      setNewAmenity('');
    }
  };
  const removeAmenity = index => {
    const updatedAmenities = [...formData.amenities];
    updatedAmenities.splice(index, 1);
    setFormData({
      ...formData,
      amenities: updatedAmenities
    });
  };
  const addImage = () => {
    if (newImage.trim() && !formData.images.includes(newImage.trim())) {
      setFormData({
        ...formData,
        images: [...formData.images, newImage.trim()]
      });
      setNewImage('');
    }
  };
  const removeImage = index => {
    const updatedImages = [...formData.images];
    updatedImages.splice(index, 1);
    setFormData({
      ...formData,
      images: updatedImages
    });
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.title.trim()) newErrors.title = 'Title is required';
    if (!formData.description.trim()) newErrors.description = 'Description is required';
    if (!formData.location.trim()) newErrors.location = 'Location is required';
    if (formData.pricePerNight <= 0) newErrors.pricePerNight = 'Price must be greater than 0';
    if (formData.bedrooms <= 0) newErrors.bedrooms = 'Must have at least 1 bedroom';
    if (formData.beds <= 0) newErrors.beds = 'Must have at least 1 bed';
    if (formData.bathrooms <= 0) newErrors.bathrooms = 'Must have at least 1 bathroom';
    if (formData.maxGuests <= 0) newErrors.maxGuests = 'Must accommodate at least 1 guest';
    if (formData.images.length === 0) newErrors.images = 'At least one image is required';
    if (!formData.host.name.trim()) newErrors.hostName = 'Host name is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (validateForm()) {
      // In a real application, this would send data to an API
      console.log('Saving property:', formData);
      onSaved();
    } else {
      console.log('Form has errors');
    }
  };
  return <div className="bg-white rounded-lg shadow" data-id="element-179">
      <form onSubmit={handleSubmit} className="p-6" data-id="element-180">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-181">
          {/* Basic Information */}
          <div className="md:col-span-2" data-id="element-182">
            <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-183">
              Basic Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-184">
              <div className="col-span-2" data-id="element-185">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-186">
                  Property Title
                </label>
                <input type="text" name="title" value={formData.title} onChange={handleChange} className={`w-full p-2 border rounded-md ${errors.title ? 'border-red-500' : 'border-gray-300'}`} data-id="element-187" />
                {errors.title && <p className="mt-1 text-sm text-red-500" data-id="element-188">{errors.title}</p>}
              </div>
              <div className="col-span-2" data-id="element-189">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-190">
                  Description
                </label>
                <textarea name="description" value={formData.description} onChange={handleChange} rows={4} className={`w-full p-2 border rounded-md ${errors.description ? 'border-red-500' : 'border-gray-300'}`} data-id="element-191"></textarea>
                {errors.description && <p className="mt-1 text-sm text-red-500" data-id="element-192">
                    {errors.description}
                  </p>}
              </div>
              <div data-id="element-193">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-194">
                  Location
                </label>
                <input type="text" name="location" value={formData.location} onChange={handleChange} className={`w-full p-2 border rounded-md ${errors.location ? 'border-red-500' : 'border-gray-300'}`} data-id="element-195" />
                {errors.location && <p className="mt-1 text-sm text-red-500" data-id="element-196">{errors.location}</p>}
              </div>
              <div data-id="element-197">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-198">
                  Property Type
                </label>
                <select name="propertyType" value={formData.propertyType} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" data-id="element-199">
                  <option value="bnb" data-id="element-200">Bed & Breakfast</option>
                  <option value="farmstay" data-id="element-201">Farmstay</option>
                </select>
              </div>
              <div data-id="element-202">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-203">
                  Price Per Night ($)
                </label>
                <input type="number" name="pricePerNight" value={formData.pricePerNight} onChange={handleChange} min="0" className={`w-full p-2 border rounded-md ${errors.pricePerNight ? 'border-red-500' : 'border-gray-300'}`} data-id="element-204" />
                {errors.pricePerNight && <p className="mt-1 text-sm text-red-500" data-id="element-205">
                    {errors.pricePerNight}
                  </p>}
              </div>
            </div>
          </div>
          {/* Property Details */}
          <div className="md:col-span-2" data-id="element-206">
            <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-207">
              Property Details
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-208">
              <div data-id="element-209">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-210">
                  Bedrooms
                </label>
                <input type="number" name="bedrooms" value={formData.bedrooms} onChange={handleChange} min="1" className={`w-full p-2 border rounded-md ${errors.bedrooms ? 'border-red-500' : 'border-gray-300'}`} data-id="element-211" />
                {errors.bedrooms && <p className="mt-1 text-sm text-red-500" data-id="element-212">{errors.bedrooms}</p>}
              </div>
              <div data-id="element-213">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-214">
                  Beds
                </label>
                <input type="number" name="beds" value={formData.beds} onChange={handleChange} min="1" className={`w-full p-2 border rounded-md ${errors.beds ? 'border-red-500' : 'border-gray-300'}`} data-id="element-215" />
                {errors.beds && <p className="mt-1 text-sm text-red-500" data-id="element-216">{errors.beds}</p>}
              </div>
              <div data-id="element-217">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-218">
                  Bathrooms
                </label>
                <input type="number" name="bathrooms" value={formData.bathrooms} onChange={handleChange} min="1" className={`w-full p-2 border rounded-md ${errors.bathrooms ? 'border-red-500' : 'border-gray-300'}`} data-id="element-219" />
                {errors.bathrooms && <p className="mt-1 text-sm text-red-500" data-id="element-220">
                    {errors.bathrooms}
                  </p>}
              </div>
              <div data-id="element-221">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-222">
                  Max Guests
                </label>
                <input type="number" name="maxGuests" value={formData.maxGuests} onChange={handleChange} min="1" className={`w-full p-2 border rounded-md ${errors.maxGuests ? 'border-red-500' : 'border-gray-300'}`} data-id="element-223" />
                {errors.maxGuests && <p className="mt-1 text-sm text-red-500" data-id="element-224">
                    {errors.maxGuests}
                  </p>}
              </div>
            </div>
          </div>
          {/* Host Information */}
          <div data-id="element-225">
            <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-226">
              Host Information
            </h3>
            <div className="space-y-4" data-id="element-227">
              <div data-id="element-228">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-229">
                  Host Name
                </label>
                <input type="text" name="name" value={formData.host.name} onChange={handleHostChange} className={`w-full p-2 border rounded-md ${errors.hostName ? 'border-red-500' : 'border-gray-300'}`} data-id="element-230" />
                {errors.hostName && <p className="mt-1 text-sm text-red-500" data-id="element-231">{errors.hostName}</p>}
              </div>
              <div data-id="element-232">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-233">
                  Host Avatar URL
                </label>
                <input type="text" name="avatar" value={formData.host.avatar} onChange={handleHostChange} className="w-full p-2 border border-gray-300 rounded-md" data-id="element-234" />
                {formData.host.avatar && <div className="mt-2" data-id="element-235">
                    <img src={formData.host.avatar} alt="Host Avatar Preview" className="w-10 h-10 rounded-full object-cover" data-id="element-236" />
                  </div>}
              </div>
            </div>
          </div>
          {/* Amenities */}
          <div data-id="element-237">
            <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-238">
              Amenities
            </h3>
            <div className="space-y-4" data-id="element-239">
              <div className="flex" data-id="element-240">
                <input type="text" value={newAmenity} onChange={e => setNewAmenity(e.target.value)} placeholder="Add an amenity" className="flex-1 p-2 border border-gray-300 rounded-l-md" data-id="element-241" />
                <button type="button" onClick={addAmenity} className="bg-[#006D77] text-white px-4 py-2 rounded-r-md" data-id="element-242">
                  <PlusIcon className="h-5 w-5" data-id="element-243" />
                </button>
              </div>
              <div className="space-y-2" data-id="element-244">
                {formData.amenities.map((amenity, index) => <div key={index} className="flex items-center bg-gray-50 p-2 rounded" data-id="element-245">
                    <span className="flex-1" data-id="element-246">{amenity}</span>
                    <button type="button" onClick={() => removeAmenity(index)} className="text-red-500 hover:text-red-700" data-id="element-247">
                      <XIcon className="h-4 w-4" data-id="element-248" />
                    </button>
                  </div>)}
                {formData.amenities.length === 0 && <p className="text-sm text-gray-500" data-id="element-249">
                    No amenities added yet
                  </p>}
              </div>
            </div>
          </div>
          {/* Images */}
          <div className="md:col-span-2" data-id="element-250">
            <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-251">
              Property Images
            </h3>
            <div className="space-y-4" data-id="element-252">
              <div className="flex" data-id="element-253">
                <input type="text" value={newImage} onChange={e => setNewImage(e.target.value)} placeholder="Add image URL" className="flex-1 p-2 border border-gray-300 rounded-l-md" data-id="element-254" />
                <button type="button" onClick={addImage} className="bg-[#006D77] text-white px-4 py-2 rounded-r-md" data-id="element-255">
                  <PlusIcon className="h-5 w-5" data-id="element-256" />
                </button>
              </div>
              {errors.images && <p className="mt-1 text-sm text-red-500" data-id="element-257">{errors.images}</p>}
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-258">
                {formData.images.map((image, index) => image && <div key={index} className="relative" data-id="element-259">
                        <img src={image} alt={`Property ${index + 1}`} className="w-full h-24 object-cover rounded" data-id="element-260" />
                        <button type="button" onClick={() => removeImage(index)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-700" data-id="element-261">
                          <XIcon className="h-4 w-4" data-id="element-262" />
                        </button>
                      </div>)}
              </div>
            </div>
          </div>
        </div>
        {/* Form Actions */}
        <div className="mt-8 flex justify-end space-x-4" data-id="element-263">
          <button type="button" onClick={onSaved} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-264">
            Cancel
          </button>
          <button type="submit" className="px-4 py-2 bg-[#006D77] text-white rounded-md hover:bg-[#005a63] flex items-center" data-id="element-265">
            <SaveIcon className="h-5 w-5 mr-2" data-id="element-266" />
            Save Property
          </button>
        </div>
      </form>
    </div>;
};
export default AdminPropertyForm;